import React from 'react';

import { Stack } from '@mui/material';
import { VTypography } from '@venti-components';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { useMarketplaceAuthenticationPage } from './hook';
import VTextInput from '../../../Venti-UI-Kit/VInputs/VTextInput/VTextInput';
import Button from '../../../Components/Buttons/Button/Button';
import { ReactComponent as SuccessImage } from '../../../assets/images/successMailValidation.svg';
import VFormCard from '../../../Venti-UI-Kit/VForms/VFormCard/VFormCard';
import BackofficePageTitle from '../../../Components/BackofficePageTitle/BackofficePageTitle';

const MarketplaceAuthenticationPage = () => {
  const {
    handleMarketplaceOauth,
    isLoading,
    handleInputChange,
    isUserLogged,
    userIsAdmin,
    accountId,
    code,
    marketplaceSuccessCreated,
  } = useMarketplaceAuthenticationPage();

  const getMarketplaceForm = () => {
    if (!isUserLogged) {
      return (
        <>
          <VTypography variant="subtitle2" textAlign="center">
            Para poder vincular tu cuenta de Mercadopago a Venti debes estar ingresado a tu cuenta
            de administrador.
          </VTypography>
          <Button
            onClick={() => {
              window.location.href = `/login?marketplaceCode=${code}`;
            }}
            title="Ingresar a tu cuenta"
            fullwidth={false}
          />
        </>
      );
    }

    if (!userIsAdmin) {
      return (
        <VTypography variant="subtitle2" textAlign="center">
          Para poder vincular tu cuenta de Mercadopago a Venti debes ser administrador.
        </VTypography>
      );
    }

    if (marketplaceSuccessCreated) {
      return (
        <>
          <SuccessImage />
          <VTypography variant="subtitle2" textAlign="center">
            Marketplace creado correctamente.
          </VTypography>
          <Button
            onClick={() => {
              window.location.href = `/eventos`;
            }}
            title="Volver al inicio"
            fullwidth={false}
          />
        </>
      );
    }

    return (
      <VFormCard>
        <Stack gap={2} alignItems="center">
          <VTextInput
            title="User ID de la cuenta de Mercado Pago"
            name="accountId"
            onChange={handleInputChange}
            value={accountId}
          />
          <Button
            onClick={handleMarketplaceOauth}
            title="Crear Marketplace"
            loading={isLoading}
            disabled={!accountId || !code || !userIsAdmin}
            fullwidth={false}
          />
        </Stack>
      </VFormCard>
    );
  };

  return (
    <PageContainer title="Mercado Pago - Autenticación cuenta">
      <BackofficePageTitle
        mainTitle="Vincular cuenta de Mercado Pago"
        secondaryTitle="Recaudá tus eventos en tu propia cuenta de Mercadopago"
      />
      <Stack
        alignSelf="center"
        alignItems="center"
        marginTop={16}
        gap={3}
        width="100%"
        maxWidth={500}
        paddingLeft={2}
        paddingRight={2}
      >
        {getMarketplaceForm()}
      </Stack>
    </PageContainer>
  );
};

export default MarketplaceAuthenticationPage;
